module.exports = __webpack_public_path__ + "static/img/hero-banner-replacement-ver5.53b67fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-banner-replacement-ver5.png
// module id = 112w
// module chunks = 73